<div class="login-lock-dialog" *ngIf="countdown$ | async as countdown">
  <h3 [innerHTML]="'Rozpoczynamy prace techniczne'">Rozpoczynamy prace techniczne 1 </h3>

  <p> Za  {{ countdown }}  min  nastąpi wylogowanie z systemu.<br>
    W czasie przerwy technicznej ponowne logowanie do systemu nie będzie możliwe.<br>
    Przewidywany czas przywrócenia działania systemu to około   {{ endAt }}  min.  </p>


  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
<!--    <div>-->
<!--      <button (click)="confirm()" mat-raised-button color="warn"><span> Tak</span></button>-->
<!--    </div>-->
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="login-lock-dialog-decline-button"><span> Zamknij</span></button>
    </div>
  </div>
</div>
